import type { FixedReport } from '@/types/content'

export const fixedReport: FixedReport = {
  reportId: 'demo-report-v1',
  assessmentId: '2000697',
  level: '중2(L7)',
  totalScore: 18,
  maxScore: 30,
  averageScore: 3.0,
  axisLabels: [
    '문제 이해·오류 인식',
    '수식화·대수 조작',
    '함수·그래프',
    '도형·공간',
    '최적화·효율성',
    '사고 전환·레퍼토리',
  ],
  axisScores: [4, 4, 4, 1, 2, 3],
  strengths:
    '문제 이해와 오류 인식, 수식화·대수 조작, 함수·그래프 영역에서 강점을 보였습니다. 조건 파악과 계산 과정이 안정적이며, 전략적 판단 능력이 잘 나타납니다.',
  improvements:
    '도형·공간 연결과 최적화·효율성 영역에서는 약간의 어려움이 있습니다. 좌표나 벡터 전환 활용과 풀이 경로 단축 연습이 필요합니다.',
  summary:
    '기초 실력은 충분하며, 도형·공간 연결과 풀이 경로 최적화만 보완하면 학습 레이더 차트의 균형이 빠르게 개선될 것입니다.',
  training:
    '체계적으로 메타인지적 수리사고력을 키우고 싶은 경우, 아래 트레이닝 사이트를 방문해 보세요. 진단평가 고유번호 2000697을 입력하면 1주일 무료 체험이 제공됩니다.',
}
